module.exports = __webpack_public_path__ + "static/feiyong-5414c3015c3bdcd50e4853aaf946c183.png";